import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import { Avatar, Abbreviate, Icon, Label } from '../../atoms';
import { DropdownMenuItem } from '../../molecules';
import { Dropdown } from '../Dropdown';

const ProfileDropupContainer = styled(Dropdown)`
  display: flex;
  width: 100%;
`;

const ProfileDropupToggle = styled.div`
  display: flex;
  column-gap: 8px;
  align-items: center;

  & * {
    cursor: pointer;
  }
`;

const ProfileDropup = ({ picture, name, onLogoutClick, isAdmin = false, className = null }) => {
  const navigate = useNavigate();

  return (
    <ProfileDropupContainer
      className={className}
      menuPlacement='bottom-start'
      menuStyle={{
        width: 240
      }}
      toggleComponent={
        <ProfileDropupToggle role='button'>
          <Avatar src={picture} alt={name} width={24} />
          <Label $color='var(--content-subtitle)'>
            <Abbreviate fullName={name} />
          </Label>
        </ProfileDropupToggle>
      }
    >
      {() => (
        <>
          <DropdownMenuItem
            onClick={() => navigate('/organization/settings')}
            leftIcon={<Icon name='store' />}
          >
            Organization
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => navigate('/organization/people')}
            leftIcon={<Icon name='user' />}
          >
            People
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => navigate('/organization/data-warehouse')}
            leftIcon={<Icon name='table' />}
          >
            Data warehouse
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => navigate('/organization/sources')}
            leftIcon={<Icon name='source' />}
          >
            Sources
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => navigate('/organization/business-logic')}
            leftIcon={<Icon name='insight' />}
          >
            Business Logic
          </DropdownMenuItem>
          {isAdmin && (
            <DropdownMenuItem
              onClick={() => navigate('/organization/question-review')}
              leftIcon={<Icon name='qa' />}
            >
              Question Review
            </DropdownMenuItem>
          )}
          <DropdownMenuItem leftIcon={<Icon name='arrow-left' />} onClick={onLogoutClick}>
            Sign out
          </DropdownMenuItem>
        </>
      )}
    </ProfileDropupContainer>
  );
};

ProfileDropup.propTypes = {
  className: PropTypes.string,
  picture: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onLogoutClick: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool
};

export { ProfileDropup };
